import React from 'react'
import { Skeleton } from '@material-ui/lab'
import { TableCell, TableRow } from '@material-ui/core'

const LoaderDataTable = ({ isCheckbox, rowsNum, columns }) => {
  let countRow = 0
  return [...Array(Number(rowsNum))].map(() => (
    <TableRow key={`loader-row-${countRow++}`}>
      {isCheckbox && (
        <TableCell key={`loader-column-check-box`} style={{ width: '50px' }}>
          <Skeleton animation="wave" variant="text" style={{ width: '50px' }} />
        </TableCell>
      )}
      {columns.map((column, index) => (
        <TableCell
          key={`loader-column-${column?.accessor ?? index}-${countRow++}`}
        >
          <Skeleton animation="wave" variant="text" style={column?.style} />
        </TableCell>
      ))}
    </TableRow>
  ))
}

export default LoaderDataTable
